import React from "react";
import IndicatoriFinanziari from "./components/IndicatoriFinanziari";
import styles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";

type Props = { reportData: any; label: string; reportData2?: any };

const IndicatoriFinanziariContainer: React.FC<Props> = ({
  reportData,
  reportData2,
  label,
}) => {
  if (!reportData) {
    return null;
  }

  if (!reportData?.indicatori_finanziari) {
    return null;
  }

  return (
    <div className={styles.sectionContainer}>
      <h3 className={styles.titleChart} style={{ marginTop: 30 }}>
        {label}
      </h3>
      <IndicatoriFinanziari reportData={reportData} reportData2={reportData2} />
    </div>
  );
};

export default React.memo(
  IndicatoriFinanziariContainer,
  (prevProps: Props, nextProps: Props) => {
    return prevProps.reportData === nextProps.reportData;
  },
);
